export default {
    namespaced: true,
    state() {
        return {
            counter: {
                liveCount: 0,
                draftCount: 0
            },
            dashboardTableLoading: false,
            apiCompletePromiseResolver: null,
            dashboardTableState: {
                tableType: 'dropShip',
                filter: {
                    searchText: '',
                    status: ''
                },
                sorting: {
                    key: 'updated_at',
                    direction: 'desc'
                },
                pagination: {
                    page: 1,
                    pageSize: 20
                }
            },
            isNewDropShipCreated: false,
            dropShipData: null,
            dropShipFormInError: false
        };
    },
    getters: {
        getCount: state => state.counter,
        getLoading: state => state.dashboardTableLoading,
        getDashboardTableState: state => state.dashboardTableState,
        isNewDropShipCreated: state => state.isNewDropShipCreated,
        getDropShipData: state => state.dropShipData,
        isDropShipFormInError: state => state.dropShipFormInError
    },
    mutations: {
        setCount(state, payload) {
            state.counter = { ...state.counter, ...payload };
        },
        setLoading(state, loading) {
            state.dashboardTableLoading = loading;
        },
        setDashboardTableState(state, payload) {
            state.dashboardTableState = payload;
        },
        setIsNewDropShipCreated(state, value) {
            state.isNewDropShipCreated = value;
        },
        setDropShipData(state, data) {
            state.dropShipData = data;
        },
        setDropShipFormInError(state, value) {
            state.dropShipFormInError = value;
        },
        setApiCompletePromiseResolver(state, resolver) {
            state.apiCompletePromiseResolver = resolver;
        },
        resolveApiCompletePromise(state) {
            if (state.apiCompletePromiseResolver) {
                state.apiCompletePromiseResolver();
                state.apiCompletePromiseResolver = null;
            }
        }
    },
    actions: {
        setCounter({ commit }, countData) {
            commit('setCount', countData);
            commit('resolveApiCompletePromise');
        },
        setDashboardTableLoading({ commit }, loading) {
            commit('setLoading', loading);
        },
        updateDashboardTableProperty({ state, commit }, payload) {
            const updates = Array.isArray(payload) ? payload : [payload];
            const currentState = { ...state.dashboardTableState };

            for (const { property, value } of updates) {
                let updated = false;

                for (const section in currentState) {
                    if (
                        typeof currentState[section] === 'object' &&
                        currentState[section] !== null &&
                        Object.prototype.hasOwnProperty.call(currentState[section], property)
                    ) {
                        currentState[section] = {
                            ...currentState[section],
                            [property]: value
                        };
                        updated = true;
                        break;
                    }
                }

                if (!updated) {
                    currentState[property] = value;
                }
            }

            commit('setDashboardTableState', currentState);
        },
        updateDashboardTablePropertyAndWaitForApi({ commit, dispatch }, payload) {
            return new Promise((resolve) => {
                // Store the resolver so it can be called when API completes
                commit('setApiCompletePromiseResolver', resolve);
                
                // Update the dashboard table property
                dispatch('updateDashboardTableProperty', payload);
            });
        }
    }
};
